document.addEventListener('DOMContentLoaded', e => {
    const catalog = document.querySelector('.catalog');

    function toggleCatalog(e) {
        if (e && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }
        if (catalog) {
            catalog.classList.toggle('catalog--with-sidebar');
        }
    }

    document.addEventListener('click', function (event) {
        if (event.target.closest('.filter-call')) {
            toggleCatalog(event);
        }
    });

    //Закриття мобыльного фільтру по кліку на оверлей
    catalog?.addEventListener('click', function (event) {
        if (event.target.classList.contains('catalog-filters')) {
            toggleCatalog(event);
        }
    });

    // Закриття по натисканню Escape
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && catalog?.classList.contains('catalog--with-sidebar')) {
            toggleCatalog(event);
        }
    });

    const catalogFilter = document.querySelector('.widget_wpc_filters_widget');
    if (catalogFilter) {
        wpcCollapse(catalogFilter);
        updateFilterCounts(catalogFilter);
        applyFilterStates(catalogFilter);
        updateMobileSummary();
        updateTotalFilterCount();


        catalogFilter.addEventListener('change', function (event) {
            if (event.target.matches('input[type="checkbox"]')) {
                updateFilterCounts(catalogFilter);
            }
        });

        // Спостерігаємо за змінами в DOM, щоб відловити AJAX-оновлення фільтрів
        const observer = new MutationObserver(mutations => {
            for (const mutation of mutations) {
                if (mutation.type === 'childList' && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
                    updateFilterCounts(catalogFilter);
                    applyFilterStates(catalogFilter);
                    updateMobileSummary();
                    updateTotalFilterCount();
                    break;
                }
            }
        });

        observer.observe(catalogFilter, {
            childList: true, // відстежувати додавання/видалення дочірніх елементів
            subtree: true    // відстежувати і у всіх вкладених елементах
        });
    }
});


//.not  .wpc-filters-section.wpc-filter-collapsible .wpc-filter-header

function wpcCollapse(catalogFilter) {
    // const catalogFilter = document.querySelector('.widget_wpc_filters_widget');
    if (!catalogFilter) return;

    catalogFilter.addEventListener('click', function (event) {
        const header = event.target.closest('.wpc-filter-header');
        if (header && !header.closest('.wpc-filters-section.wpc-filter-collapsible')) {
            const filterContainer = header.closest('.wpc-filters-section');
            if (!filterContainer) return;

            const fid = filterContainer.dataset.fid;
            filterContainer.classList.toggle('open');

            if (fid) {
                const isOpen = filterContainer.classList.contains('open');
                localStorage.setItem(`filterState-${fid}`, isOpen ? 'open' : 'closed');
            }
        }
    });
}

function updateFilterCounts(filterWidget) {
    //const filterWidget = document.querySelector('.widget_wpc_filters_widget');

    if (!filterWidget) return;

    const sections = filterWidget.querySelectorAll('.wpc-filters-section');

    sections.forEach(section => {
        const header = section.querySelector('.wpc-filter-header');
        if (!header) return;

        const checkedCount = section.querySelectorAll('input[type="checkbox"]:checked').length;
        let countBadge = header.querySelector('.catalog-filters__group-num');

        if (!countBadge) {
            header.insertAdjacentHTML('beforeend', '<div class="catalog-filters__group-num"></div>');
            countBadge = header.querySelector('.catalog-filters__group-num');
        }

        countBadge.setAttribute('data-count', checkedCount);
    });
}

function applyFilterStates(filterWidget) {
    if (!filterWidget) return;

    const sections = filterWidget.querySelectorAll('.wpc-filters-section[data-fid]');
    sections.forEach(section => {
        const fid = section.dataset.fid;
        const savedState = localStorage.getItem(`filterState-${fid}`);

        if (savedState === 'open') {
            section.classList.add('open');
        } else if (savedState === 'closed') {
            section.classList.remove('open');
        }
    });
}

function updateMobileSummary() {
    const source = document.querySelector('.catalog__top-bar__left');
    const destination = document.querySelector('.catalog-filters__mobile-summary');

    if (source && destination) {
        destination.innerHTML = source.innerHTML;
    }
}


// Функція оновлення загальної кількості застосованих фільтрів
function updateTotalFilterCount() {
    const totalCountBadge = document.querySelector('.catalog-filters__head > .catalog-filters__group-num');
    const filtersList = document.querySelector('.catalog__top-bar .catalog__top-bar__filters-list');

    if (totalCountBadge && filtersList) {
        const filterItemsCount = filtersList.querySelectorAll('a:not(.filter-clear)').length;
        totalCountBadge.setAttribute('data-count', filterItemsCount);
    }
}
